import { INews } from '../../../APIPackage/NewsModule/interfaces/INews';
import { num2str } from './num2str';

export function getAnnounceLeftTime(announce: INews): string {
  let result = '';

  if (!announce.published || !announce.countdownStop) {
    return result;
  }

  const alarmDate = new Date(announce.countdownStop);

  alarmDate.setHours(alarmDate.getHours() - 3);

  let leftTime = alarmDate.getTime() - Date.now();

  leftTime = Math.trunc(leftTime / 1000 / 60);

  if (leftTime < 0) {
    return '0 минут';
  }

  const leftMinutes = leftTime % 60;

  leftTime = Math.trunc(leftTime / 60);

  const leftHours = leftTime % 24;
  const leftDays = Math.trunc(leftTime / 24);

  if (leftDays > 0) {
    result += `${leftDays} ${num2str(leftDays, ['день', 'дня', 'дней'])}`;
  }

  if (leftHours > 0 || result) {
    result += `${result ? ', ' : ''}${leftHours} ${num2str(leftHours, ['час', 'часа', 'часов'])}`;
  }

  result += `${result ? ', ' : ''}${leftMinutes} ${num2str(leftMinutes, ['минута', 'минуты', 'минут'])}`;

  return result;
}
